<template>
  <b-card>
    <div style="overflow-x: auto">
      <table class="table">
        <thead class="center-th">
          <tr>
            <th rowspan="3">{{ $t("general.object_name") }}</th>
            <th rowspan="2" colspan="2">{{ $t("general.about_project") }}</th>
            <th colspan="8">{{ $t("general.status_flat") }}</th>
          </tr>
          <tr>
            <th scope="col" colspan="2">{{ $t("general.sold") }}</th>
            <th scope="col" colspan="2">{{ $t("general.occupied") }}</th>
            <th scope="col" colspan="2">{{ $t("general.busy") }}</th>
            <th scope="col" colspan="2">{{ $t("general.free") }}</th>
          </tr>
          <tr>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
          </tr>
        </thead>

        <tbody class="center-td">
          <tr v-for="item in GET_OVERALL_TABLE" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.total_flat_count }}</td>
            <td>{{ item.total_flat_area }}</td>
            <td>{{ item.total_sold_flat_count }}</td>
            <td>{{ item.total_sold_flat_area }}</td>
            <td>{{ item.total_management_bron_flat_count }}</td>
            <td>{{ item.total_management_bron_flat_area }}</td>
            <td>{{ item.total_occupied_flat_count }}</td>
            <td>{{ item.total_occupied_flat_area }}</td>
            <td>{{ item.total_available_flat_count }}</td>
            <td>{{ item.total_available_flat_area }}</td>
          </tr>
          <tr style="background-color: #f3f2f7">
            <td>
              {{ $t('general.last') }}
            </td>
            <td>{{ totalFlatCount }}</td>
            <td>{{ totalFlatArea }}</td>
            <td>{{ totalSoldFlatCount }}</td>
            <td>{{ totalSoldFlatArea }}</td>
            <td>{{ totalManagementBronFlatCount }}</td>
            <td>{{ totalManagementBronFlatArea }}</td>
            <td>{{ totalOccupiedFlatCount }}</td>
            <td>{{ totalOccupiedFlatArea }}</td>
            <td>{{ totalAvailableFlatCount }}</td>
            <td>{{ totalAvailableFlatArea }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BCard, BSpinner, BTr, BTh, BTable } from "bootstrap-vue";
import formatters from "@/mixins/extra";

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: false,

      fields: [
        {
          key: "id",
          label: "ID",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "title",
          label: "Obyekt nomi",
        },
        {
          key: "total_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("objects", ["GET_REPORTS_TABLE", "GET_OVERALL_TABLE"]),
    totalAvailableFlatArea() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_available_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalAvailableFlatCount() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_available_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalOccupiedFlatArea() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_occupied_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalOccupiedFlatCount() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_occupied_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalManagementBronFlatArea() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_management_bron_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalManagementBronFlatCount() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_management_bron_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalSoldFlatArea() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_sold_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalSoldFlatCount() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_sold_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalFlatArea() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalFlatCount() {
      let data = this.GET_OVERALL_TABLE.map((item) => {
        return item.total_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
  },

  mounted() {
    this.FETCH_OVERALL_TABLE();
    // this.FETCH_REPORTS_TABLE().then(() => {
    //   this.loader = false;
    // });
  },

  methods: {
    ...mapActions("objects", ["FETCH_REPORTS_TABLE", "FETCH_OVERALL_TABLE"]),
  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}

.center-th th {
  vertical-align: middle !important;
  text-align: center !important;
}
.center-td td {
  vertical-align: middle !important;
  text-align: center !important;
}
</style>
